/**
 * @generated SignedSource<<7e247a1ef4e6a42f567d7a6b198d595b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type ConfigChangeStartStopSageIntacctRecipesInput = {
  sageIntacctTimeRegsFromForecast?: boolean | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type configChangeStartStopSageIntacctRecipesMutation$variables = {
  input: ConfigChangeStartStopSageIntacctRecipesInput;
};
export type configChangeStartStopSageIntacctRecipesMutation$data = {
  readonly configChangeStartStopSageIntacctRecipes: {
    readonly outcome: string | null;
  } | null;
};
export type configChangeStartStopSageIntacctRecipesMutation = {
  variables: configChangeStartStopSageIntacctRecipesMutation$variables;
  response: configChangeStartStopSageIntacctRecipesMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ConfigChangeStartStopSageIntacctRecipesPayload",
    "kind": "LinkedField",
    "name": "configChangeStartStopSageIntacctRecipes",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "outcome",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "configChangeStartStopSageIntacctRecipesMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "configChangeStartStopSageIntacctRecipesMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "4f2c4bd2c5e3f7e6b5bffa9bf5b4524b",
    "id": null,
    "metadata": {},
    "name": "configChangeStartStopSageIntacctRecipesMutation",
    "operationKind": "mutation",
    "text": "mutation configChangeStartStopSageIntacctRecipesMutation(\n  $input: ConfigChangeStartStopSageIntacctRecipesInput!\n) {\n  configChangeStartStopSageIntacctRecipes(input: $input) {\n    outcome\n  }\n}\n"
  }
};
})();

(node as any).hash = "a2a838c0e0d3e6efa66f359db05223eb";

export default node;
